import { getConditionalObject } from 'utils/data';

export const normalizeForm = ({ form, entityId }) => {
  const {
    intendToOccupyPropertyAsPrimaryResidence,
    ownershipInterestPastThreeYears,
    pastThreeYearsPropertyPurpose,
    titleHoldingType,
    relationshipWithPropertySeller,
    partOfDownPaymentBorrowed,
    partOfDownPaymentBorrowedAmount,
    loanOnAnotherProperty,
    anyNewCreditOutsideOfTheLoan,
    isPropertyLien,
  } = form[entityId]?.declarations?.propertyAndLoan ?? {};

  return {
    ...form,
    [entityId]: {
      ...form[entityId],
      declarations: {
        ...form[entityId]?.declarations,
        propertyAndLoan: {
          intendToOccupyPropertyAsPrimaryResidence,

          ownershipInterestPastThreeYears,
          ...getConditionalObject(ownershipInterestPastThreeYears, {
            pastThreeYearsPropertyPurpose,
            titleHoldingType,
          }),

          ...getConditionalObject(relationshipWithPropertySeller !== undefined, {
            relationshipWithPropertySeller,
          }),

          partOfDownPaymentBorrowed,
          ...getConditionalObject(partOfDownPaymentBorrowed, {
            partOfDownPaymentBorrowedAmount,
          }),

          loanOnAnotherProperty,
          anyNewCreditOutsideOfTheLoan,
          isPropertyLien,
        },
      },
    },
  };
};
